var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtension1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.919,
    y1: 0.403,
    x2: 0.283,
    y2: 0.817,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.087,
    y1: 0.592,
    x2: 0.722,
    y2: 0.18,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7659",
    "data-name": "Group 7659",
    transform: "translate(0 -0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3990",
    "data-name": "Rectangle 3990",
    transform: "translate(0 0.139)",
    fill: "#fff",
    stroke: "#eee",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 90,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7658",
    "data-name": "Group 7658",
    transform: "translate(25.696 25.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M39.143,19.333,21.518,1.708,19.81,0h0L6.543,13.267h0L.477,19.333a1.622,1.622,0,0,0,0,2.292L12.6,33.746l7.212,7.212L33.077,27.691l.205-.205,5.86-5.86a1.622,1.622,0,0,0,0-2.292Zm-19.333,7.2-6.055-6.055,6.055-6.055,6.055,6.055Z",
    transform: "translate(-0.003)",
    fill: "#2684ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M25.214,14.324A10.1,10.1,0,0,1,25.171.09L12.05,13.206l7.141,7.141Z",
    transform: "translate(-5.505 -0.042)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M42.652,37.85,36.64,43.862a10.1,10.1,0,0,1,0,14.283h0L49.793,44.991Z",
    transform: "translate(-16.735 -17.186)",
    fill: "url(#linear-gradient-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtension1);
export default __webpack_public_path__ + "static/media/extension1.8e1cc300c6d6a1db2393c5d035a83b9c.svg";
export { ForwardRef as ReactComponent };